import { Button } from '@mui/material'
import { useNavigate } from 'react-router-dom'

const WelcomeScreen = () => {
    const navigate = useNavigate()
    const handleNavigation = () => {
        navigate('/dashboard')
    }
    return (
        <div className="not-found-main">
            <div className="not-found-body">
                <Button
                    variant="outlined"
                    onClick={handleNavigation}
                    className="welcome-button"
                    sx={{ textTransform: 'capitalize' }}
                >
                    Go to Dashboard
                </Button>
            </div>
            <div className='empty-space'></div>
        </div>
    )
}

export default WelcomeScreen
